import { Indicator, IndicatorStyles } from '..';
import styled from 'styled-components';

const SynthesisLine = styled.div<{ margin?: string }>`
  display: flex;
  flex: 1;
  line-height: 15px;
  margin: ${(props) => props.margin ?? 'initial'};
`;

const S = {
  Container: styled.div`
    padding: 10px;
    color: ${(props) => props.theme.algoanBlue};
  `,
  Title: styled.h3`
    background: ${(props) => props.theme.legacy.lightGrey};
    border-radius: 4px;
    font-size: 12px;
    font-weight: bold;
    height: 25px;
    line-height: 25px;
    padding-left: 11px;
    text-transform: uppercase;
  `,
  LoadingMessage: styled.div`
    color: ${(props) => props.theme.algoanBlue};
    padding: 9px;
  `,
  Error: styled.div`
    color: ${(props) => props.theme.legacy.danger};
  `,
  Divider: styled.div`
    height: 2px;
    background-color: #ffffff;
    margin: 10px 0;
  `,
  Section: styled.div`
    padding: 0 10px;
  `,
  Table: styled.table`
    table-layout: fixed;
    border-collapse: separate;
    border-spacing: 0;
    padding: 0 10px;
    width: 100%;
    td:last-child ${SynthesisLine} {
      margin-left: 25px;
    }
    tr:not(:first-child) {
      ${SynthesisLine} {
        margin-top: 14px;
      }
      td {
        border-top: 2px solid #ffffff;
      }
    }
    tr:not(:last-child) ${SynthesisLine} {
      margin-bottom: 14px;
    }
  `,
  SectionRow: styled.div`
    display: flex;
    & > *:not(:last-child) {
      margin-right: 25px;
    }
    margin-bottom: 10px;
  `,
  LeftColumn: styled.div`
    width: calc(50% - 25px);
  `,
  LineTitle: styled.div<{ secondary?: boolean; underline?: boolean }>`
    flex: 1;
    ${(props) =>
      props.secondary
        ? `
        font-size: 11px;
      `
        : `
        font-size: 10px;
        font-weight: bold;
        text-transform: uppercase;
      `}

    ${(props) =>
      props.underline
        ? `text-decoration: underline;
       cursor: pointer;
       `
        : ''}
  `,
  LineValue: styled.div<{ secondary?: boolean; color?: string }>`
    text-align: right;
    text-transform: uppercase;
    font-size: 12px;
    margin-left: 5px;
    ${(props) =>
      props.secondary
        ? ''
        : `
      font-weight: bold;
      `}
    ${(props) => (props.color ? `color: ${props.color};` : '')}
  `,
  Link: styled.a<{ fullWidth?: boolean }>`
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    ${(props) => (props.fullWidth ? 'flex: 1;' : '')}
  `,
  InfoMessage: styled.div`
    font-size: 11px;
  `,
  IndicatorsContainer: styled.div<{ displayOnOneColumn: boolean }>`
    display: flex;
    ${(props) => (props.displayOnOneColumn ? 'flex-direction: column;' : 'flex-wrap: wrap;')}
  `,
  BoldIndicatorValue: styled.div`
    font-weight: bold;
  `,
  BoldAndCapitalisedWarningValue: styled.div<{ underline?: boolean }>`
    font-weight: bold;
    text-transform: uppercase;
    font-size: 10px;
    margin-top: 2px;

    ${(props) =>
      props.underline
        ? `
  text-decoration: underline;
  cursor: pointer;
  `
        : ''}
  `,
  Warning: styled.img.attrs({ src: '/images/warning.png', alt: 'warning' })`
    margin-right: 7px;
    height: 12px;
  `,
  BoldAndCapitalisedLocdrawdownValue: styled.div`
    font-weight: bold;
    text-transform: uppercase;
    font-size: 10px;
    margin-top: 2px;
    cursor: pointer;
    text-decoration: underline;
  `,
  CapitalisedValue: styled.div`
    text-transform: uppercase;
  `,
  NonBoldTitle: styled.div`
    font-size: 11px;
    text-transform: lowercase;

    &:first-letter {
      text-transform: uppercase;
    }
  `,
  NonBoldUpperCaseTitle: styled.div`
    font-size: 11px;
  `,
  PaymentIndicators: styled.div`
    margin-top: 10px;
    width: calc(50% - 25px);
    & > * :not(:last-child) {
      margin-bottom: 5px;
    }
    margin-right: 25px;
  `,
  PaymentsContainer: styled.div`
    display: flex;
    flex-wrap: wrap;
    flex: 1;
  `,
  WrappedIndicator: styled(Indicator)`
    white-space: pre-wrap;
    margin-bottom: 0;

    ${IndicatorStyles.IndicatorTitle} {
      padding-right: 10px;
    }
  `,
};

export const CommonSynthesisStyles = { ...S, SynthesisLine };
